import { withSearch } from '@elastic/react-search-ui';
import DateRangeFilters from '../../../components/filter/DateRangeFilter';

function ResearchReportsDateRangeFilter({ setFilter, removeFilter, filters }) {
  return (
    <DateRangeFilters
      filters={filters}
      formHint="For example, 27 3 2007"
      fromFieldId="dateFrom"
      id="date-range"
      label="Date of publication"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="dateTo"
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(ResearchReportsDateRangeFilter);
